import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const canceledOrder = (id, storeId, orderId, data) => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/cancel',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const canceledOrderB2B = (id, storeId, challanId, data) => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/challan/' +
      challanId,
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
